(function () {
  'use strict';

  angular
    .module('morningFlightAfterNightFlight')
    .service('morningFlightAfterNightFlightService', morningFlightAfterNightFlightService);

  function morningFlightAfterNightFlightService(CommonMasterData,RemoteService) {
    var vm = this;

    vm.searchMorningFlightAfterNightFlight = function (param ,successFn,errorFn) {
      var searchParam = adaptSearchRequset(param);
      RemoteService.searchMorningFlightAfterNightFlight(searchParam).then(
        function (response) {
          successFn(response);
        },
        function (error) {
          errorFn(error.msg);
        }
      );
    };

    function adaptSearchRequset(param) {
      var actualSearchParam = {
        fromDate : param.fromDate,
        toDate: param.toDate,
        crewType:(param.crewType !=null ) ? param.crewType.crewTypeCode:null,
        autoOrManual: (param.autoOrManual != null) ? param.autoOrManual.autoOrManualCode:null
      };

      return actualSearchParam;
    }

  }
}());
